import { render } from "./tab-booking-in-progress.vue?vue&type=template&id=8ec7fb18&scoped=true&ts=true"
import script from "./tab-booking-in-progress.vue?vue&type=script&lang=ts"
export * from "./tab-booking-in-progress.vue?vue&type=script&lang=ts"

import "./tab-booking-in-progress.vue?vue&type=style&index=0&id=8ec7fb18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec7fb18"]])

export default __exports__